export const slugifyCategory = (value = '') =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const categoryPath = (categoryName = '') => `/categories/${slugifyCategory(categoryName)}`;
